// removed by extract-text-webpack-plugin
module.exports = {"bar":"src-App-pages-Home-components-FloatingButton-module__bar--1LW1U","btn":"src-App-pages-Home-components-FloatingButton-module__btn--1GQRG","divider":"src-App-pages-Home-components-FloatingButton-module__divider--1CwVx","img":"src-App-pages-Home-components-FloatingButton-module__img--VQ23R"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/components/FloatingButton.module.scss
// module id = 832
// module chunks = 0